<template>
<div class="chapter">
<div class="inner_page">
<p class="head">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1. A Man and His Passion</a></p>
<p class="toc"><a href="#/chapter2">2. Professional Baseball Comes to Boston</a></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. Miracle Braves</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. Braves Field</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5. Interesting Player Stories</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6. Braves Managers</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7. Braves Owners</span></p>
<p class="toc"><span href="#/inter1" title="Link target outside of Sample"><i>Interlude One</i></span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">8. A Visit to Braves Field Today</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">9. Braves Player/Fan Reunion</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Sam Gentile</span></p>
<p class="toc"><span href="#/inter2" title="Link target outside of Sample"><i>Interlude Two</i></span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Life After Baseball</span></p>
<p class="toc1"><span href="#/spring" title="Link target outside of Sample">Spring Training Sites</span></p>
<p class="toc"><span href="#/sources" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f5b6108c